import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { User, BarChart3 } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import { UserModal } from '../ui/modals/UserModal';
import { CTPStatsModal } from './CTPStatsModal';

export const CTPTopBar: React.FC = () => {
  const { user } = useAuth();
  const [showUserModal, setShowUserModal] = useState(false);
  const [showStatsModal, setShowStatsModal] = useState(false);

  return (
    <>
      <div
        className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between px-4 h-12 bg-background"
        style={{ paddingTop: 'env(safe-area-inset-top)', height: 'calc(3rem + env(safe-area-inset-top))' }}
      >
        {/* Logo + Brand */}
        <Link to="/" aria-label="Back to Wallstreetle" className="flex items-center gap-2">
          <img
            src="/assets/site-logo/mini-transparent-dark-logo.svg"
            alt="Wallstreetle"
            className="w-7 h-7"
          />
          <span
            className="hidden sm:inline font-serif text-lg tracking-wide"
            style={{ color: 'hsl(var(--foreground))' }}
          >
            WALLSTREETLE
          </span>
        </Link>

        {/* Title — centered */}
        <span
          className="absolute left-1/2 -translate-x-1/2 font-serif text-lg tracking-tight"
          style={{ color: 'hsl(var(--foreground))' }}
        >
          Compare the Pair
        </span>

        {/* Stats + Login / Profile */}
        <div className="flex items-center gap-3">
          <button
            onClick={() => setShowStatsModal(true)}
            className="hover:opacity-80 transition-opacity"
            style={{ color: 'hsl(var(--foreground))' }}
            aria-label="Statistics"
          >
            <BarChart3 className="w-5 h-5" />
          </button>
          <button
            onClick={() => setShowUserModal(true)}
            className="hover:opacity-80 transition-opacity"
            style={{ color: 'hsl(var(--foreground))' }}
            aria-label={user ? 'Profile' : 'Login'}
          >
            {user ? (
              <User className="w-5 h-5" />
            ) : (
              <span className="text-sm font-medium">Login</span>
            )}
          </button>
        </div>
      </div>

      <UserModal isOpen={showUserModal} onClose={() => setShowUserModal(false)} />
      <CTPStatsModal
        isOpen={showStatsModal}
        onClose={() => setShowStatsModal(false)}
        onSignInClick={() => setShowUserModal(true)}
      />
    </>
  );
};
